const ScholarReferIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      opacity="0.4"
      d="M10 10H30V28C26.6875 28 24 30.6875 24 34H16C16 30.6875 13.3125 28 10 28V10ZM10 30C12.2062 30 14 31.7938 14 34H12C10.8937 34 10 33.1063 10 32V30ZM14 20C14 23.3125 16.6875 26 20 26C23.3125 26 26 23.3125 26 20C26 16.6875 23.3125 14 20 14C16.6875 14 14 16.6875 14 20ZM26 34C26 31.7938 27.7938 30 30 30V32C30 33.1063 29.1063 34 28 34H26Z"
      fill="#FDC8D3"
    />
    <path
      d="M7 6C5.34375 6 4 7.34375 4 9V15C4 15.55 3.55 16 3 16C2.45 16 2 15.55 2 15V9C2 6.2375 4.2375 4 7 4H33C35.7625 4 38 6.2375 38 9V15C38 15.55 37.55 16 37 16C36.45 16 36 15.55 36 15V9C36 7.34375 34.6562 6 33 6H7ZM30 32V30C27.7937 30 26 31.7938 26 34H28C29.1062 34 30 33.1062 30 32ZM24 34C24 30.6875 26.6875 28 30 28V10H32V32C32 34.2062 30.2062 36 28 36H12C9.79375 36 8 34.2062 8 32V10H10V28C13.3125 28 16 30.6875 16 34H24ZM14 34C14 31.7938 12.2062 30 10 30V32C10 33.1062 10.8937 34 12 34H14ZM20 24C22.2062 24 24 22.2063 24 20C24 17.7937 22.2062 16 20 16C17.7937 16 16 17.7937 16 20C16 22.2063 17.7937 24 20 24ZM20 14C23.3125 14 26 16.6875 26 20C26 23.3125 23.3125 26 20 26C16.6875 26 14 23.3125 14 20C14 16.6875 16.6875 14 20 14Z"
      fill="#374151"
    />
  </svg>
);

export default ScholarReferIcon;
